// import request from '@/middleware/request'

// const getNlu = () => {
//   return request({
//     url: '/nlu',
//     method: 'get'
//   })
// }

// const getDataBeforebuildNlu = () => {
//   return request({
//     url: '/nlu/data_before_build',
//     method: 'get'
//   })
// }

// const getCheckBuilding = () => {
//   return request({
//     url: '/nlu/check_building',
//     method: 'get'
//   })
// }

// const buildNlu = data => {
//   return request({
//     url: '/nlu/build',
//     method: 'post',
//     data
//   })
// }

// const goLiveNlu = id => {
//   return request({
//     url: `/nlu/go_live/${id}`,
//     method: 'patch'
//   })
// }

// const customThreshold = (id, data) => {
//   return request({
//     url: `/nlu/threshold/${id}`,
//     method: 'patch',
//     data
//   })
// }

// const deleteNlu = (id, data) => {
//   return request({
//     url: `/nlu/${id}`,
//     method: 'delete',
//     data
//   })
// }

// const getTestNlu = data => {
//   return request({
//     url: `/nlu/predict`,
//     method: 'post',
//     data
//   })
// }

// const bulkImport = formData => {
//   return request({
//     url: '/nlu/bulk/import',
//     method: 'post',
//     timeout: 300000, // 5 mins
//     headers: {
//       'Content-Type': 'multipart/form-data'
//     },
//     data: formData
//   })
// }

// const exportsNlu = name => {
//   return request({
//     url: `/nlu/exportnlu/${name}`,
//     method: 'get',
//     responseType: 'blob'
//   })
// }
// //========= use for Intellisense ========
// const getNluEntity = data => {
//   return request({
//     url: `/nlu/get-nlu-entity`,
//     method: 'post',
//     data
//   })
// }
// //========= use for Intellisense ========
// export default {
//   getNlu,
//   getDataBeforebuildNlu,
//   getCheckBuilding,
//   buildNlu,
//   goLiveNlu,
//   customThreshold,
//   deleteNlu,
//   getTestNlu,
//   bulkImport,
//   exportsNlu,
//   getNluEntity
// }

import request from '@/middleware/request'

const getNluEntity = () => {
  return request({
    url: `/ai/legacy/intellisense-entities`,
    method: 'get'
  })
}

export default {
  getNluEntity
}
